import { render, staticRenderFns } from "./course-item.vue?vue&type=template&id=4a88f46b&scoped=true"
import script from "./course-item.vue?vue&type=script&lang=js"
export * from "./course-item.vue?vue&type=script&lang=js"
import style0 from "./course-item.vue?vue&type=style&index=0&id=4a88f46b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a88f46b",
  null
  
)

export default component.exports